import React, { useEffect } from 'react';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import { isMobile } from '../../config';

import S from './Solution.module.css';

import { card_01, card_02, card_03, card_04, card_05, card_06, card_07 } from '../../assets/images/solution/solutionImages';

const RfidPage = () => {
  useEffect(() => {
    window.scrollTo(0, 327);
    
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  return (
    <div>
      <HeaderComponents pageKey="solution" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="solution" />
        </div>
        <div className='com-content-wrap mt-200'>
          <div className={isMobile() ? 'mb-50' : 'mb-80'}>
            <img src={card_01} alt='Title' className={`${S.solContentImg} mt-30`} />
          </div>
          <div className='mb-50'>
            <div className={S.textLineDiv}></div>
            <div className={S.titleText}>
              RFID/NFC 카드인쇄란
            </div>
            <div className={`${S.smallContentText} mt-20`}>
              RFID/NFC 모든 종류 카드제작이 가능합니다.<br />
              출입통제, 식수관리, 주차관제, 자재관리, 회원관리 등 다양한 곳에서 RFID/NFC를 사용하고 있습니다.<br /><br />
              125Khz EM, HID, Temic / 13.56Mhz MF, ICODE, Ntag / 900Mhz Gen2 등<br />
              다양한 종류의 카드를 모두 제작이 가능합니다.
            </div>
            <img src={card_02} alt='card' className={`${S.solContentImg} mt-50`}/>
          </div>
          <div className='mb-50'>
            <div className={S.textLineDiv}></div>
            <div className={S.titleText}>
              특수 인쇄카드
            </div>
            <div className={`${S.smallContentText} mt-20`}>
              골드카드, 메탈카드, 에폭시카드, 친환경 우드카드 등 특수 인쇄 제작 가능
            </div>
            <img src={card_03} alt='card' className={`${S.solContentImg} mt-50`}/>
          </div>
          <div className='mb-50'>
            <div className={S.textLineDiv}></div>
            <div className={S.titleText}>
              특수 인쇄카드
            </div>
            <div className={`${S.smallContentText} mt-20`}>
              골드카드, 메탈카드, 에폭시카드, 친환경 우드카드 등 특수 인쇄 제작 가능
            </div>
            <img src={card_04} alt='card' className={`${S.solContentImg} mt-50`}/>
            <div className={`${S.cardInputText} ${S.solContentImg} flex-row `}>
              <span>[ 옵셋 프레스 ]</span>
              <span>[ UV 건조기 ]</span>
              <span>[ RFID 인레이 시트 ]</span>
            </div>
            <img src={card_05} alt='card' className={`${S.solContentImg} mt-40`}/>
            <div className={`${S.cardInputText} ${S.solContentImg} flex-row `}>
              <span>[ 마그네틱, 홀로그램, 박, 펄 등 후가공기]</span>
              <span>[ 타공, 타발기 ]</span>
              <span>[ 인레이 스티커 프레스 ]</span>
            </div>
          </div>
          <div className='mb-50'>
            <div className={S.textLineDiv}></div>
            <div className={S.titleText}>
              미니 태그
            </div>
            <div className={`${S.smallContentText} mt-20`}>
              신용카드 사이즈 이외 다양한 사이즈로 카드 제작이 가능
            </div>
            <img src={card_06} alt='card' className={`${S.solContentImg} mt-50`}/>
          </div>
          <div className='mb-50'>
            <div className={S.textLineDiv}></div>
            <div className={S.titleText}>
              200여개의 무료 카드시안 제공
            </div>
            <div className={`${S.smallContentText} mt-20`}>
              엠포플러스에서는 200여개 이상의 다양한 카드 디자인시안을 무료로 제공
            </div>
            <img src={card_07} alt='card' className={`${S.solContentImg} mt-50`}/>
          </div>
        </div>

      </div>
    </div>
  );
};

export default RfidPage;
